import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonDigging } from '@fortawesome/free-solid-svg-icons/faPersonDigging';
import type { IconProps } from '../../types';

export function PersonDiggingIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Person Digging',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faPersonDigging}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
